























import {Component, Emit, Model, Prop, Vue} from "vue-property-decorator";
import {FreightServiceAddStore} from "@/modules/freightserviceadds/store";
import debounce from "lodash/debounce";
import FreightServiceLabel from "@/modules/freightservices/List/components/Label.vue";
import {FreightServiceParams} from "@/modules/freightservices/params";
import {CommonStatus} from "@/enums/status";
import {FreightServiceAddParams} from "@/modules/freightserviceadds/params";
import FreightServiceAddLabel from "@/modules/freightserviceadds/List/components/Label.vue";

@Component({
    name: "FreightServiceAddSelector",
    components: {FreightServiceAddLabel, FreightServiceLabel}
})
export default class extends Vue {
    @Prop({default: 'default'}) readonly size!: 'default' | 'small' | 'large';
    @Model("change")
    readonly freightServiceAddRowGuid!: string|string[]|undefined[];

    @Emit('change')
    handleChange(value: number) {
        return value;
    }

    @Prop({ default: false, type: Boolean })
    readonly disabled!: boolean;

    @Prop({ default: "default", type: String })
    readonly mode!: string;

    get ids() {
        return FreightServiceAddStore.ids;
    }

    async created() {
        try {
            await FreightServiceAddStore.listFreightServiceAdd({ ...new FreightServiceAddParams(), status: CommonStatus.Active });
        } catch (e) {
            this.$notification.error({ message: "Thất bại", description: e?.response?.data?.message || "Đã có lỗi xảy ra" });
        }
    }

    private onSearch = debounce(async (value: string) => {
        await FreightServiceAddStore.listFreightServiceAdd({...new FreightServiceParams(), search: value, status: CommonStatus.Active});
    }, 500);
}
